import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ISagaCb } from '@typings/requestPayloads'

export interface IAllExhibitorMeetingStatsPayloadState extends ISagaCb {}

export interface IState {
    status: string
    data: any
    errors: any
}

const initialState: IState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const allExhibitorMeetingStatsSlice = createSlice({
    name: 'meeting-statistics/all-exhibitor-meeting-stats',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IAllExhibitorMeetingStatsPayloadState>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const allExhibitorMeetingStatsActions = allExhibitorMeetingStatsSlice.actions
export default allExhibitorMeetingStatsSlice.reducer
